import { take } from "redux-saga/effects";
import { LOGOUT_USER_SUCCESS } from "../../auth/constants";

export function* disconnect(socket) {
  while (true) {
    yield take(LOGOUT_USER_SUCCESS);
    socket.disconnect();
  }
}
